// Pure helpers for the Sources tab (kept out of the component file so fast
// refresh keeps working): how a ledger row reads on the page.
import type { RoadmapSource } from '../../services/roadmapReports';

export const KIND_LABELS: Record<RoadmapSource['source_kind'], string> = {
  meeting: 'meeting',
  email_thread: 'email',
  document: 'document',
  notes: 'notes',
};

export function shortDate(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export function shortId(id: string | null): string {
  return id ? id.slice(0, 8) : '';
}

/** How a source reads on the page: a meeting by its title and date, anything else by its id. */
export function sourceLabel(s: RoadmapSource): string {
  if (s.label) {
    const when = shortDate(s.started_at);
    return when ? `${s.label} (${when})` : s.label;
  }
  if (s.source_kind === 'document' && s.source_id.startsWith('kb:')) return `knowledge bank entry ${s.source_id.slice(3, 11)}`;
  return `${KIND_LABELS[s.source_kind]} ${shortId(s.source_id)}`;
}


/** How a triage verdict reads on the page; '' when the meeting was never judged. */
export function triageLabel(s: RoadmapSource): string {
  const t = s.triage;
  if (!t) return '';
  if (t.state === 'failed') return 'triage failed, counted as new';
  if (t.state !== 'judged' || !t.verdict) return '';
  return t.verdict === 'hold' ? 'triage: held back (nothing for the roadmap)' : 'triage: woke a run';
}
